import { configuredAxios } from '@/dataAccess/api'
import { ApiRequestStatus } from '@/dataAccess/ApiRequestStatus'

/**
 * Abstract base class for objects requested from the API for a specific view.
 * Unlike Models they are not stored in the Vuex store.
 */
export default class DTO {
  static axios = configuredAxios

  static get url(): string {
    throw Error(
      'Subclasses are expected to override `url` for fetching data from API.'
    )
  }

  /**
   * Subclasses are expected to have a constructor
   * which accepts the data in the same format as it comes from the API.
   */
  // eslint-disable-next-line
  constructor(apiData: object = null) {
  }


  static async getAllFromApi() {
    try {
      const result = await this.axios.get(this.url)
      return [result.data.map(o => new this(o)), ApiRequestStatus.ofSuccess()]
    } catch (e) {
      // eslint-disable-next-line
      console.error(e)
      return [null, ApiRequestStatus.ofError()]
    }
  }
}

export type ApiResponse = Record<string, number | string | boolean>
